import { render, staticRenderFns } from "./Habilitacao.vue?vue&type=template&id=393ec8ee"
import script from "./Habilitacao.vue?vue&type=script&lang=js"
export * from "./Habilitacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports